angular.module("componentes").component("radioButton", {
	templateUrl: "componentes/angular-material/custom/fields/radioButton/radioButton_template.html",
	bindings: {
		title: "@",
		value: "@",
		subtitle: "@?",
		class: "@?"
	}
});
